import React from 'react';
import { Link } from 'react-router-dom';

export default function CoachContact() {
  return (
    <div className="main-content yss-site--main__content Bullets numBullets">
      <div className="main-site__content">
        <div className="page__content">
          <div className="section--wrapper">
            <div className="section--width">
              <div className="information_block block--para--lists">
                <div className="block--title">
                  <h2>Coacherly coaches’ terms and conditions</h2>
                </div>
                <ul>
                  <li>
                    <strong>Interpretation</strong>
                  </li>
                </ul>
                <ul className="noListStyle">
                  <li>
                    <strong>1.1 Definitions</strong>
                  </li>
                </ul>
                <ul>
                  <li>
                    <strong>Business Day</strong>: a day other than a Saturday,
                    Sunday or national holiday in the United States.
                  </li>
                  <li>
                    <strong>Coach</strong>: the coaching professional offering
                    (or intending to offer) Services through the Coacherly
                    Platform.
                  </li>
                  <li>
                    <strong>Coacherly Fee</strong>: 10% of the Session Fee, plus
                    value added tax (or other similar tax) at the prevailing
                    rate.
                  </li>
                  <li>
                    <strong>Coacherly General Terms and Conditions</strong>: the
                    terms set out here:
                    <Link to="/terms-and-conditions">LINK</Link>.
                  </li>
                  <li>
                    <strong>Coacherly Materials</strong>: all materials,
                    equipment, documentation, specifications and data supplied
                    by Coacherly to the Coach.
                  </li>
                  <li>
                    <strong>Coacherly Platform</strong>: the Coacherly coaching
                    platform, available on the website coacherly.com, which is a
                    property wholly owned and operated by the Connecticut
                    Community for Addiction Recovery (“CCAR”), located in the
                    U.S. State of Connecticut.
                  </li>
                  <li>
                    <strong>Coach IPRs</strong>: all Intellectual Property
                    Rights subsisting in material prepared by the Coach
                    excluding any Coacherly Materials incorporated in them.
                  </li>
                  <li>
                    <strong>Conditions</strong>: these terms and conditions set
                    out in clause 1 (Interpretation) to clause 9 (General)
                    (inclusive).
                  </li>
                  <li>
                    <strong>Contract</strong>: the contract between Coacherly
                    and the Coach for the supply of the Services in accordance
                    with these Conditions.
                  </li>
                  <li>
                    <strong>End User</strong>: a client receiving the Services
                    through the Coacherly Platform.
                  </li>
                  <li>
                    <strong>Intellectual Property Rights</strong>: commercially
                    valuable products of the human intellect, in a concrete or
                    abstract form such as copyrightable works, protectable
                    trademarks, patentable inventions, or trade secrets and all
                    other intellectual property rights, in each case whether
                    registered or unregistered and including all applications
                    and rights to apply for and be granted, renewals or
                    extensions of, and rights to claim priority from, such
                    rights and all similar or equivalent rights or forms of
                    protection which subsist or will subsist now or in the
                    future in any part of the world.
                  </li>
                  <li>
                    <strong>Services</strong>: the recovery coaching services to
                    be provided by the Coach through the Coacherly Platform.
                  </li>
                  <li>
                    <strong>Services Start Date</strong>: the day on which the
                    Coach is to start provision of the Services through the
                    Coacherly Platform, as agreed between the parties.
                  </li>
                  <li>
                    <strong>Session Fee</strong>: the amount charged by a Coach
                    to the End User for a coaching session, to be charged to the
                    End User by Coacherly via Stripe Connect (or other similar
                    service).{' '}
                  </li>
                </ul>
                <ul className="pl--0">
                  <p>
                    <strong>1.2 Interpretation</strong>
                  </p>
                </ul>
                <ol className="listABC">
                  <li>
                    {' '}
                    A reference to legislation or a legislative provision:
                    <p className="pl--10 mt--0">
                      (i) is a reference to it as amended, extended or
                      re-enacted from time to time; and
                    </p>
                    <p className="pl--10 mt--0">
                      (ii) shall include all subordinate legislation made from
                      time to time under that legislation or legislative
                      provision.
                    </p>
                  </li>
                  <li>
                    Any words following the terms{' '}
                    <strong>
                      including, include, in particular, for example
                    </strong>{' '}
                    or any similar expression shall be construed as illustrative
                    and shall not limit the sense of the words, description,
                    definition, phrase or term preceding those terms.
                  </li>
                  <li>
                    A reference to <strong>writing</strong> or{' '}
                    <strong>written</strong> includes email.
                  </li>
                </ol>
                <ul className="noList">
                  <li>
                    <strong>2. Commencement and term</strong>
                  </li>
                  <li>
                    <span>2.1 </span> In submitting a registration request to
                    Coacherly, the Coach agrees to be bound by the Coacherly
                    General Terms And Conditions{' '}
                    <Link to="/terms-and-conditions">LINK</Link> and this
                    Contract.{' '}
                  </li>
                  <li>
                    <span>2.2 </span> The Contract shall commence on the date
                    when it has been accepted by both parties and shall
                    continue, unless terminated earlier in accordance with its
                    terms, until either party gives to the other not less than
                    one months' written notice to terminate.
                  </li>
                  <li>
                    <span>2.3 </span> Either party may terminate this Contract
                    on 30 days’ written notice.
                  </li>
                </ul>
                <ul className="noList">
                  <li>
                    3. <strong>Supply of services</strong>
                  </li>
                  <li>
                    <span>3.1 </span>3.1 CCAR shall provide the Coach with
                    access to the Coacherly Platform (including the ability for
                    Coacherly to take bookings and payments on the Coach’s
                    behalf and allow the Coach access to a private online video
                    call system for the purpose of coaching sessions) and the
                    Coach shall supply the Services to End Users from the
                    Services Start Date in accordance with the Contract.
                  </li>
                  <li>
                    <span>3.2 </span> In supplying the Services, the Coach
                    shall:
                    <ol className="listABCInner mt--0">
                      <li className="mt--0">
                        provide End Users with the Coach’s contractual terms and
                        conditions and agree terms of engagement. Copies of any
                        relevant documentation shall be provided to Coacherly on
                        request;
                      </li>
                      <li>
                        perform the Services with reasonable care, skill and
                        diligence and in accordance with any service
                        description;{' '}
                      </li>
                      <li>
                        ensure that all advice given to End Users is in
                        accordance with good industry practice;{' '}
                      </li>
                      <li>
                        ensure that at all times it holds and maintains any and
                        all necessary professional qualifications,
                        accreditations and memberships, and allow and assist
                        CCAR with verifying and investigating the same;
                      </li>
                      <li>
                        assist CCAR as necessary in the preparation of the
                        Coach’s account on the Coacherly Platform and ensure
                        that all information provided to CCAR is accurate;
                      </li>
                      <li>
                        ensure that any goods, materials, standards and
                        techniques used in providing the Services are of
                        satisfactory quality and are fit for purpose;
                      </li>
                      <li>
                        comply with all applicable laws, statutes, regulations
                        and codes from time to time in force, provided that the
                        Coach shall not be liable under the Contract if, as a
                        result of such compliance, it is in breach of any of its
                        obligations under the Contract;
                      </li>
                      <li>
                        not sell, loan, or allow access to any third party to
                        the Coach’s account on the Coacherly Platform;
                      </li>
                      <li>
                        not advertise or sell any other products or services
                        when providing the Services; and
                      </li>
                      <li>
                        take reasonable care of all Coacherly Materials in its
                        possession and make them available for collection by
                        CCAR on reasonable notice and request, always provided
                        that the Coach may destroy Coacherly Materials if CCAR
                        fails to collect Coacherly Materials within a reasonable
                        period after termination of the Contract.
                      </li>
                    </ol>
                  </li>
                </ul>
                <ul className="noList">
                  <li>
                    3.3 The Coach warrants and undertakes that it shall exercise
                    all the reasonable skill, care and diligence to be expected
                    of a qualified and experienced member of the Coach’s
                    profession providing the Services on works similar in scope
                    and character to the Services.
                  </li>
                  <li>
                    3.4 The Coach shall indemnify CCAR in full against any sums
                    awarded by a court against CCAR arising out of or in
                    connection with any claim brought against CCAR for arising
                    out of or in connection with a breach of clause 3.
                  </li>
                </ul>
                <ul className="noList">
                  <li>
                    <strong>4. Coacherly's obligations</strong>
                  </li>
                  <li>
                    <span>4.1 Coacherly shall: </span>
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      provide the Coach with access to the Coacherly Platform;{' '}
                    </li>
                    <li>
                      co-operate with the Coach in all matters relating to the
                      Services;
                    </li>
                    <li>
                      provide, in a timely manner, such information as the Coach
                      may reasonably require, and ensure that it is accurate and
                      complete in all material respects; and
                    </li>
                    <li>
                      use commercially reasonable endeavours to make the
                      Coacherly Platform available 24 hours a day, seven days a
                      week, except for:
                      <p class="pl--10 mt--0">
                        (i) planned maintenance carried out during the
                        maintenance window of 10:00 pm to 2:00 am US Eastern
                        Time; and
                      </p>
                      <p class="pl--10 mt--0">
                        (ii) unscheduled maintenance performed outside normal
                        business hours, provided that CCAR has used reasonable
                        endeavours to give the Customer at least 6 normal
                        business hours' notice in advance.
                      </p>
                    </li>
                  </ol>
                </ul>
                <ul className="noList">
                  <li>4.2 Coacherly does not warrant that:</li>
                  <ol className="listABCInner mt--0">
                    <li>
                      use of the Coacherly Platform will be uninterrupted or
                      error-free; or
                    </li>
                    <li>free from vulnerabilities or viruses</li>
                  </ol>
                  <li>
                    and is not responsible for any delays, delivery failures, or
                    any other loss or damage resulting from the transfer of data
                    over communications networks and facilities, including the
                    internet, and the Coach acknowledges that the Coacherly
                    Platform may be subject to limitations, delays and other
                    problems inherent in the use of such communications
                    facilities.
                  </li>
                  <li>
                    4.3 The Coach acknowledges and agrees that CCAR and/or its
                    licensors own all intellectual property rights in the
                    Coacherly Platform. Except as expressly stated herein, this
                    agreement does not grant the Coach any rights to, under or
                    in, any patents, copyright, database right, trade secrets,
                    trade names, trademarks (whether registered or
                    unregistered), or any other rights or licenses in respect of
                    the Coacherly Platform.
                  </li>
                </ul>
                <ul className="noList">
                  <li>
                    5. <strong>Data protection </strong>
                  </li>
                  <li>The following definitions apply in this clause:</li>
                  <ul className="noList">
                    <li>
                      <strong>Agreed Purposes</strong>: the performance of
                      Services under this agreement
                    </li>
                    <li>
                      <strong>
                        Controller, processor, data subject, personal data,
                        personal data breach, processing and appropriate
                        technical and organisational measures
                      </strong>
                      : as set out in the Data Protection Legislation.
                    </li>
                    <li>
                      <strong>Data Discloser</strong>: a party that discloses
                      Shared Personal Data to the other party.
                    </li>
                    <li>
                      <strong>Data Protection Legislation:</strong>
                    </li>
                    <li>
                      1.1 To the extent the UK GDPR applies, the law of the
                      United Kingdom or of a part of the United Kingdom which
                      relates to the protection of personal data.
                    </li>
                    <li>
                      1.2 To the extent the EU GDPR applies, the law of the
                      European Union or any member state of the European Union
                      to which the party is subject, which relates to the
                      protection of personal data.
                    </li>
                    <li>
                      1.3 To the extent U.S. data privacy laws apply, the law of
                      the applicable state to which the party is subject, which
                      relates to the protection of personal data.
                    </li>
                    <li>
                      1.4 To the extent other global data privacy laws apply,
                      the law of the applicable jurisdiction to which the party
                      is subject, which relates to the protection of personal
                      data.
                    </li>
                    <li>
                      <strong>EU GDPR</strong>: the General Data Protection
                      Regulation ((EU) 2016/679).
                    </li>
                    <li>
                      <strong>UK GDPR</strong>: has the meaning given to it in
                      section 3(10) (as supplemented by section 205(4)) of the
                      Data Protection Act 2018.
                    </li>
                    <li>
                      <strong>Permitted Recipients</strong>: the parties to this
                      agreement, the employees of each party, any third parties
                      engaged to perform obligations in connection with this
                      agreement.
                    </li>
                    <li>
                      <strong>Shared Personal Data: </strong>the personal data
                      to be shared between the parties under clause 1.1 of this
                      agreement. Shared Personal Data shall be confined to the
                      following categories of information relevant to the
                      following categories of data subject: End Users’
                      usernames, passwords (hashed), and details voluntarily
                      given during coaching sessions.
                    </li>
                    <li>
                      <strong>5.1 Shared Personal Data</strong>: This clause
                      sets out the framework for the sharing of personal data
                      between the parties as controllers. Each party
                      acknowledges that one party (referred to in this clause as
                      the <strong>Data Discloser</strong>) will regularly
                      disclose to the other party Shared Personal Data collected
                      by the Data Discloser for the Agreed Purposes.
                    </li>
                    <li>
                      <strong>
                        5.2 Effect of non-compliance with Data Protection
                        Legislation
                      </strong>
                      . Each party shall comply with all the obligations imposed
                      on a controller under the Data Protection Legislation, and
                      any material breach of the Data Protection Legislation by
                      one party shall, if not remedied within 30 days of written
                      notice from the other party, give grounds to the other
                      party to terminate this agreement with immediate effect.{' '}
                    </li>
                    <li>
                      <strong>
                        5.3 Particular obligations relating to data sharing
                      </strong>
                      . Each party shall:
                    </li>
                    <ol className="listABCInner mt--0">
                      <li>
                        ensure that it has all necessary notices and consents
                        and lawful bases in place to enable lawful transfer of
                        the Shared Personal Data to the Permitted Recipients for
                        the Agreed Purposes;
                      </li>
                      <li>
                        give full information to any data subject whose personal
                        data may be processed under this agreement of the nature
                        of such processing. This includes giving notice that, on
                        the termination of this agreement, personal data
                        relating to them may be retained by or, as the case may
                        be, transferred to one or more of the Permitted
                        Recipients, their successors and assignees;
                      </li>
                      <li>
                        process the Shared Personal Data only for the Agreed
                        Purposes;
                      </li>
                      <li>
                        not disclose or allow access to the Shared Personal Data
                        to anyone other than the Permitted Recipients;
                      </li>
                      <li>
                        ensure that all Permitted Recipients are subject to
                        written contractual obligations concerning the Shared
                        Personal Data (including obligations of confidentiality)
                        which are no less onerous than those imposed by this
                        agreement;
                      </li>
                      <li>
                        ensure that it has in place appropriate technical and
                        organisational measures, reviewed and approved by the
                        other party, to protect against unauthorised or unlawful
                        processing of personal data and against accidental loss
                        or destruction of, or damage to, personal data;
                      </li>
                      <li>
                        not transfer any personal data received from the Data
                        Discloser outside the UK unless the transferor ensures
                        that (i) the transfer is to a country approved under the
                        applicable Data Protection Legislation as providing
                        adequate protection; or (ii) there are appropriate
                        safeguards or binding corporate rules in place pursuant
                        to the applicable Data Protection Legislation; or (iii)
                        the transferor otherwise complies with its obligations
                        under the applicable Data Protection Legislation by
                        providing an adequate level of protection to any
                        personal data that is transferred; or (iv) one of the
                        derogations for specific situations in the applicable
                        Data Protection Legislation applies to the transfer.
                      </li>
                    </ol>
                  </ul>
                </ul>
                <ul className="noList">
                  <li>
                    5.4. <strong>Mutual assistance. </strong>Each party shall
                    assist the other in complying with all applicable
                    requirements of the Data Protection Legislation. In
                    particular, each party shall:
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      consult with the other party about any notices given to
                      data subjects in relation to the Shared Personal Data;
                    </li>
                    <li>
                      promptly inform the other party about the receipt of any
                      data subject rights request;
                    </li>
                    <li>
                      provide the other party with reasonable assistance in
                      complying with any data subject rights request;
                    </li>
                    <li>
                      not disclose, release, amend, delete or block any Shared
                      Personal Data in response to a data subject rights request
                      without first consulting the other party wherever
                      possible;
                    </li>
                    <li>
                      assist the other party, at the cost of the other party, in
                      responding to any request from a data subject and in
                      ensuring compliance with its obligations under the Data
                      Protection Legislation with respect to security, personal
                      data breach notifications, data protection impact
                      assessments and consultations with the Information
                      Commissioner or other regulators;{' '}
                    </li>
                    <li>
                      notify the other party without undue delay on becoming
                      aware of any breach of the Data Protection Legislation;
                    </li>
                    <li>
                      at the written direction of the Data Discloser, delete or
                      return Shared Personal Data and copies thereof to the Data
                      Discloser on termination of this agreement unless required
                      by law to store the Shared Personal Data;
                    </li>
                    <li>
                      use compatible technology for the processing of Shared
                      Personal Data to ensure that there is no lack of accuracy
                      resulting from personal data transfers;
                    </li>
                    <li>
                      maintain complete and accurate records and information to
                      demonstrate its compliance with this clause 5 and allow
                      for audits by the other party or the other party's
                      designated auditor; and
                    </li>
                    <li>
                      provide the other party with contact details of at least
                      one employee as point of contact and responsible manager
                      for all issues arising out of the Data Protection
                      Legislation, including the joint training of relevant
                      staff, the procedures to be followed in the event of a
                      data security breach, and the regular review of the
                      parties' compliance with the Data Protection Legislation.
                    </li>
                  </ol>
                </ul>
                <ul className="noList">
                  <li>
                    5.5 <strong>Indemnity. </strong>Each party shall indemnify
                    the other against all liabilities, costs, expenses, damages
                    and losses (including but not limited to any direct,
                    indirect or consequential losses, loss of profit, loss of
                    reputation and all interest, penalties and legal costs
                    (calculated on a full indemnity basis) and all other
                    reasonable professional costs and expenses) suffered or
                    incurred by the indemnified party arising out of or in
                    connection with the breach of the Data Protection
                    Legislation by the indemnifying party, its employees or
                    agents, provided that the indemnified party gives to the
                    indemnifier prompt notice of such claim, full information
                    about the circumstances giving rise to it, reasonable
                    assistance in dealing with the claim and sole authority to
                    manage, defend and/or settle it.{' '}
                  </li>
                  <li>
                    <strong>6. Intellectual property</strong>
                  </li>
                  <li>
                    6.1 The Coach and its licensors shall retain ownership of
                    all Coach IPRs. CCAR and its licensors shall retain
                    ownership of all Intellectual Property Rights in Coacherly
                    Materials.
                  </li>
                  <li>
                    6.2 The Coach grants CCAR, or shall procure the direct grant
                    to CCAR of, a fully paid-up, worldwide, non-exclusive,
                    royalty-free, license to copy and modify the Coach IPRs for
                    the purpose of providing the Coach access to the Coacherly
                    platform during the term of the Contract.
                  </li>
                  <li>
                    6.3 CCAR grants the Coach a fully paid-up, worldwide,
                    non-exclusive, royalty-free, non-transferable license to
                    copy and modify Coacherly Materials for the term of the
                    Contract for the purpose of providing the Services via the
                    Coacherly Platform in accordance with the Contract.
                  </li>
                  <li>
                    6.4 The Coach shall indemnify CCAR in full against any sums
                    awarded by a court against CCAR arising out of or in
                    connection with any claim brought against CCAR for
                    infringement of a third party's rights (including any
                    Intellectual Property Rights) arising out of or in
                    connection with the receipt or use of the Services via the
                    Coacherly Platform.
                  </li>
                  <li>
                    6.5 CCAR shall indemnify the Coach in full against any sums
                    awarded by a court against the Coach arising of or in
                    connection with any claim brought against the Coach for
                    infringement of a third party's rights (including any
                    Intellectual Property Rights) arising out of, or in
                    connection with, the receipt or use of Coacherly Materials
                    by the Coach.
                  </li>
                </ul>
                <ul className="noList">
                  <li>
                    <strong>7. Charges and payment </strong>
                  </li>
                  <li>
                    7.1 In consideration of the Coach’s presence on the
                    Coacherly Platform, CCAR shall retain the Coacherly Fee in
                    accordance with this clause 7.
                  </li>
                  <li>
                    7.2 The balance of the Session Fee shall, after payment has
                    been made by the End User and the deductions set out in
                    clause 7.1 are made, be paid to the Coach after the end of a
                    coaching session. Payment is made automatically via the
                    Stripe Connect (or other similar service), normally within
                    five days.
                  </li>
                  <li>
                    7.3 If CCAR fails to make any payment due to the Coach under
                    the Contract within 14 days of the due date for payment,
                    then, without limiting the Coach's remedies under clause 9
                    (Termination):
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      (a) CCAR shall pay interest on the overdue sum from the
                      due date until payment of the overdue sum, whether before
                      or after judgment. Interest under this clause will accrue
                      each day at 4% a year above the U.S. Federal Reserve’s
                      federal funds rate from time to time, but at 4% a year for
                      any period when that base rate is below 0%.
                    </li>
                    <li>
                      the Coach may suspend all Services until payment has been
                      made in full.{' '}
                    </li>
                  </ol>
                </ul>
                <ul className="noList">
                  <li>
                    <strong>8. Limitation of liability</strong>
                  </li>
                  <li>
                    8.1 References to liability in this 8 include every kind of
                    liability arising under or in connection with the Contract
                    including but not limited to liability in contract, tort
                    (including negligence), misrepresentation, restitution or
                    otherwise.{' '}
                  </li>
                  <li>
                    8.2 Neither party may benefit from the limitations and
                    exclusions set out in this clause in respect of any
                    liability arising from its deliberate default.
                  </li>
                  <li>
                    8.3 Nothing in this clause 8 shall limit CCAR’s payment
                    obligations under the Contract.
                  </li>
                  <li>
                    8.4 Nothing in the agreement shall limit the parties’
                    liability under clauses 3, 5 or 6 of the Contract.
                  </li>
                  <li>
                    8.5 Nothing in the Contract limits any liability which
                    cannot legally be limited, including but not limited to
                    liability for:
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>death or personal injury caused by negligence;</li>
                    <li>fraud or fraudulent misrepresentation; and</li>
                    <li>
                      breach of the terms implied by section 2 of the Supply of
                      Goods and Services Act 1982 (title and quiet possession).{' '}
                    </li>
                  </ol>
                  <li>
                    8.6 Subject to clause 8.2 (No limitation in respect of
                    deliberate default), clause 8.3 (No limitation on CCAR’s
                    payment obligations), clause 8.4 (Liability under identified
                    clauses) and clause 8.5 (Liabilities which cannot legally be
                    limited):
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      the Coach's total liability to CCAR shall not exceed the
                      amount paid to the Coach in the previous 12 months.
                    </li>
                    <li>
                      (b) CCAR’s total liability to the Coach for all other loss
                      or damage shall not exceed the amount paid to the Coach in
                      the previous 12 months.
                    </li>
                  </ol>
                  <li>
                    8.7 The caps on the parties' liabilities shall not be
                    reduced by:{' '}
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>payment of an uncapped liability;</li>
                    <li>
                      amounts awarded or agreed to be paid under clause 6; and
                    </li>
                    <li>
                      amounts awarded by a court or arbitrator, using their
                      procedural or statutory powers in respect of costs of
                      proceedings or interest for late payment.{' '}
                    </li>
                  </ol>
                  <li>
                    8.8 Subject to clause 8.3 (No limitation in respect of
                    deliberate default), clause 8.4 (No limitation on CCAR’s
                    payment obligations), clause 8.5 (Liability under identified
                    clauses) and clause 8.6 (Liabilities which cannot legally be
                    limited), this clause 8.9 sets out the types of loss that
                    are wholly excluded:
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>loss of profits;</li>
                    <li>loss of sales or business;</li>
                    <li>loss of agreements or contracts;</li>
                    <li>loss of anticipated savings;</li>
                    <li>
                      loss of use or corruption of software, data or
                      information;
                    </li>
                    <li>loss of or damage to goodwill; and</li>
                    <li>indirect or consequential loss.</li>
                  </ol>
                  <li>
                    8.9 The parties have given commitments as to compliance of
                    services with relevant specifications in clause 3 and 4. In
                    view of these commitments, the terms implied by sections 3,
                    4 and 5 of the (UK) Supply of Goods and Services Act 1982
                    and other global laws with similar intent are, to the
                    fullest extent permitted by law, excluded from the Contract.
                  </li>
                  <li>
                    <strong>9. Termination</strong>
                  </li>
                  <li>
                    9.1 Without affecting any other right or remedy available to
                    it, either party to the Contract may terminate it with
                    immediate effect by giving written notice to the other party
                    if:
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      the other party commits a material breach of any term of
                      the Contract which breach is irremediable or (if such
                      breach is remediable) fails to remedy that breach within a
                      period of 14 days after being notified in writing to do
                      so;{' '}
                    </li>
                    <li>
                      the other party suspends, or threatens to suspend, or
                      ceases or threatens to cease to carry on all or a
                      substantial part of its business; or
                    </li>
                    <li>
                      the other party's financial position deteriorates to such
                      an extent that in the terminating party's reasonable
                      opinion the other party's capability to adequately fulfil
                      its obligations under the Contract has been placed in
                      jeopardy.
                    </li>
                  </ol>
                  <li>
                    9.2 Without affecting any other right or remedy available to
                    it, the Coach may terminate the Contract with immediate
                    effect by giving written notice to CCAR if CCAR fails to pay
                    any amount due under the Contract in accordance with clause
                    7.
                  </li>
                  <li>
                    9.3 Without affecting any other right or remedy available to
                    it, CCAR may terminate the Contract or suspend the Coach’s
                    account on the Coacherly Platform with immediate effect by
                    giving written notice to the Coach if in CCAR’s reasonable
                    opinion the Coach is failing to provide the Services in
                    accordance with clause 3.
                  </li>
                  <li>
                    9.4 On termination of the Contract for whatever reason:
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      any provision of the Contract that expressly or by
                      implication is intended to come into or continue in force
                      on or after termination or expiry of the Contract shall
                      remain in full force and effect; and
                    </li>
                    <li>
                      termination or expiry of the Contract shall not affect any
                      of the rights, remedies, obligations or liabilities of the
                      parties that have accrued up to the date of termination or
                      expiry, including the right to claim damages in respect of
                      any breach of the Contract which existed at or before the
                      date of termination or expiry.
                    </li>
                  </ol>
                  <li>
                    <strong>10. General</strong>
                  </li>
                  <li>
                    10.1 <strong>Force majeure</strong>. Neither party shall be
                    in breach of the Contract nor liable for delay in
                    performing, or failure to perform, any of its obligations
                    under the Contract if such delay or failure result from
                    events, circumstances or causes beyond its reasonable
                    control.{' '}
                  </li>
                  <li>
                    10.2 <strong>Assignment and other dealings.</strong>
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      The Coach shall not assign, transfer, charge, subcontract,
                      declare a trust over or deal in any other manner with any
                      or all of its rights and obligations under the Contract
                      without Coacherly's prior written consent.{' '}
                    </li>
                    <li>
                      CCAR may at any time assign, transfer, charge,
                      subcontract, declare a trust over or deal in any other
                      manner with any or all of its rights under the Contract.
                    </li>
                  </ol>
                  <li>
                    10.3 <strong>Confidentiality.</strong>
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      Each party undertakes that it shall not at any time
                      disclose to any person any confidential information
                      concerning the business, affairs, customers, clients or
                      suppliers of the other party or of any member of the{' '}
                      <strong>group</strong> to which the other party belongs,
                      except as permitted by 10.3. For the purposes of this
                      10.3, group means, in relation to a party, that party, any
                      subsidiary or holding company from time to time of that
                      party, and any subsidiary from time to time of a holding
                      company of that party.
                    </li>
                    <li>
                      Each party may disclose the other party's confidential
                      information:
                      <p className="pl--10 mt--0">
                        (i) to its employees, officers, representatives,
                        contractors, subcontractors or advisers who need to know
                        such information for the purposes of carrying out the
                        party's obligations under the Contract. Each party shall
                        ensure that its employees, officers, representatives,
                        contractors, subcontractors or advisers to whom it
                        discloses the other party's confidential information
                        comply with this 10.3; and
                      </p>
                      <p className="pl--10 mt--0">
                        (ii) as may be required by law, a court of competent
                        jurisdiction or any governmental or regulatory
                        authority.
                      </p>
                    </li>
                    <li>
                      Neither party shall use any other party's confidential
                      information for any purpose other than to perform its
                      obligations under the Contract.
                    </li>
                  </ol>
                  <li>
                    10.4 <strong>Entire agreement. </strong>
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      The Contract constitutes the entire agreement between the
                      parties and supersedes and extinguishes all previous
                      agreements, promises, assurances, warranties,
                      representations and understandings between them, whether
                      written or oral, relating to its subject matter.
                    </li>
                    <li>
                      Each party acknowledges that in entering into the Contract
                      it does not rely on and shall have no remedies in respect
                      of any statement, representation, assurance or warranty
                      (whether made innocently or negligently) that is not set
                      out in the Contract. Each party agrees that it shall have
                      no claim for innocent or negligent misrepresentation [or
                      negligent misstatement] based on any statement in the
                      Contract.
                    </li>
                  </ol>
                  <li>
                    10.5 <strong>Variation</strong>. No variation of the
                    Contract shall be effective unless it is in writing and
                    signed by the parties (or their authorised representatives).{' '}
                  </li>
                  <li>
                    10.6 <strong>Waiver. </strong>
                  </li>
                  <ol className="listABCInner mt--0">
                    <li>
                      A waiver of any right or remedy under the Contract or by
                      law is only effective if given in writing and shall not be
                      deemed a waiver of any subsequent right or remedy.
                    </li>
                    <li>
                      A failure or delay by a party to exercise any right or
                      remedy provided under the Contract or by law shall not
                      constitute a waiver of that or any other right or remedy,
                      nor shall it prevent or restrict any further exercise of
                      that or any other right or remedy. No single or partial
                      exercise of any right or remedy provided under the
                      Contract or by law shall prevent or restrict the further
                      exercise of that or any other right or remedy.
                    </li>
                  </ol>
                  <li>
                    10.7 <strong>Severance.</strong> If any provision or
                    part-provision of the Contract is or becomes invalid,
                    illegal or unenforceable, it shall be deemed modified to the
                    minimum extent necessary to make it valid, legal and
                    enforceable. If such modification is not possible, the
                    relevant provision or part-provision shall be deemed
                    deleted. Any modification to or deletion of a provision or
                    part-provision under this 10.7 shall not affect the validity
                    and enforceability of the rest of the Contract.
                  </li>
                  <li>
                    10.8 <strong>Notices.</strong>
                  </li>
                  <ol className="listABCInner">
                    <li>
                      Any notice given to a party under or in connection with
                      the Contract shall be in writing and shall be:
                      <p className="pl--10 mt--0">
                        (i) sent by email to the other party’s main email
                        address.{' '}
                      </p>
                    </li>
                    <li>
                      Any notice shall be deemed to have been received at the
                      time of transmission, or, if this time falls outside
                      business hours in the place of receipt, when business
                      hours resume. In this clause 10.8(b) business hours means
                      9.00am to 5.00pm Monday to Friday on a day that is not a
                      public holiday in the place of receipt.
                    </li>
                    <li>
                      This clause 10.8 does not apply to the service of any
                      proceedings or other documents in any legal action or,
                      where applicable, any arbitration or other method of
                      dispute resolution.
                    </li>
                  </ol>
                  <li>
                    10.9 <strong>Third party rights.</strong>{' '}
                  </li>
                  <li>
                    The Contract does not give rise to any rights under the
                    Contracts (Rights of Third Parties) Act 1999 to enforce any
                    term of the Contract.
                  </li>
                  <li>
                    10.10 <strong>Governing law</strong>. The Contract, and any
                    dispute or claim (including non-contractual disputes or
                    claims) arising out of or in connection with it or its
                    subject matter or formation, shall be governed by, and
                    construed in accordance with Connecticut state law, or with
                    the laws of the United States of America, as governed by the
                    U.S. District Court in Connecticut, as appropriate depending
                    on jurisdiction.
                  </li>
                  <li>
                    10.11 <strong>Jurisdiction</strong>. Each party irrevocably
                    agrees that the courts of the state of Connecticut (or, in
                    the event of international disputes, the U.S. District Court
                    in Connecticut) shall have exclusive jurisdiction to settle
                    any dispute or claim (including non-contractual disputes or
                    claims) arising out of or in connection with the Contract or
                    its subject matter or formation.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Contract/CoachContract.js